/**
 * Shared constants for the case blocks grid layout.
 */

/** Number of columns in the grid */
export const GRID_COLUMNS = 6;

/** Height of each row in pixels (Tailwind: auto-rows-[90px]) */
export const ROW_HEIGHT = 90;

/** Gap between grid cells in pixels (Tailwind: gap-2 = 0.5rem = 8px) */
export const GRID_GAP = 8;

/** RGL margin configuration [horizontal, vertical] */
export const RGL_MARGIN: [number, number] = [GRID_GAP, GRID_GAP];

/** RGL container padding [horizontal, vertical] */
export const RGL_CONTAINER_PADDING: [number, number] = [0, 0];

/** Maximum height of a block in rows */
export const MAX_BLOCK_HEIGHT = 25;
